export default __webpack_public_path__ + "assets/fonts/rouble-webfont-491628f8.woff";